var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "rb-btn rb-btn--video",
          attrs: { type: "button" },
          on: { click: _vm.showModal },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("rb-modal", {
        attrs: {
          show: _vm.modalActive,
          "handle-close": _vm.closeModal,
          "modal-class": "rb-video-modal",
          "modal-wrapper-class": "main",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "modal-header",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
            {
              key: "modal-content",
              fn: function () {
                return [
                  _vm.type === "html"
                    ? _c(
                        "div",
                        {
                          staticClass: "video-container video-container--html",
                        },
                        [
                          _c(
                            "video",
                            {
                              attrs: {
                                preload: "metadata",
                                width: "640",
                                height: "360",
                                controls: "",
                                autoplay: "",
                              },
                            },
                            [_vm._t("video")],
                            2
                          ),
                        ]
                      )
                    : _vm.type && _vm.videoId
                    ? _c("rb-embedded-video", {
                        attrs: { type: _vm.type, "video-id": _vm.videoId },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }